import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, gbp } from "../../lib/api";

const STATUS_STYLE = {
  new: "border-[#FFCC00] text-[#FFCC00]",
  reviewing: "border-white/40 text-white/60",
  accepted: "border-green-500 text-green-500",
  rejected: "border-[#FF3B30] text-[#FF3B30]",
};

export const AdminSubmissions = () => {
  const [subs, setSubs] = useState([]);

  const load = () => api.get("/admin/submissions").then(({ data }) => setSubs(data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/submissions/${id}`, { status });
    toast.success(`Marked ${status}`);
    load();
  };

  if (subs.length === 0)
    return <div className="border border-[#27272A] p-16 text-center font-display text-2xl text-white/30" data-testid="admin-submissions-empty">NO SUPPLIER SUBMISSIONS YET.</div>;

  return (
    <div className="space-y-px bg-[#27272A] border border-[#27272A]" data-testid="admin-submissions-list">
      {subs.map((s) => (
        <div key={s.id} className="bg-[#0A0A0A] p-6">
          <div className="flex flex-wrap justify-between items-start gap-4">
            <div>
              <div className="flex items-center gap-3">
                <span className="font-display text-xl">{s.company}</span>
                <span className={`text-[10px] uppercase tracking-widest px-2 py-1 border ${STATUS_STYLE[s.status]}`}>{s.status}</span>
              </div>
              <div className="text-white/40 text-xs mt-1">{s.contact_name} · {s.email} · {s.phone} · {new Date(s.created_at).toLocaleDateString("en-GB")}</div>
            </div>
            <div className="text-right text-xs text-white/50">
              {s.est_units && <div>{s.est_units} units est.</div>}
              {s.asking_price != null && <div className="text-[#FFCC00]">Asking {gbp(s.asking_price)}</div>}
            </div>
          </div>
          <p className="text-white/60 text-sm mt-4 border-l-2 border-[#27272A] pl-4">{s.stock_description}</p>
          <div className="flex gap-2 mt-4">
            {["reviewing", "accepted", "rejected"].map((st) => (
              <button
                key={st}
                data-testid={`admin-submission-${st}-${s.id}`}
                onClick={() => setStatus(s.id, st)}
                disabled={s.status === st}
                className="btn-ghost-industrial px-4 py-1.5 text-sm disabled:opacity-30"
              >
                {st.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
